import { FlexBox } from '@dixa/lib-shared-habla';

import { FeatureCard } from './components/featureCard/featureCard';

type CopilotFeaturesRowProps = {
  showLearnMore?: boolean;
};
export const CopilotFeaturesRow = ({
  showLearnMore = true,
}: CopilotFeaturesRowProps): JSX.Element => {
  return (
    <FlexBox
      flexDirection="row"
      gap={showLearnMore ? '300' : '200'}
      flexWrap="wrap"
      padding="400 0 400 0"
    >
      <FeatureCard
        title="Smart Replies"
        description="Boost efficiency with AI + Knowledge base."
        icon="autocomplete"
        learnMoreLink={
          showLearnMore
            ? 'https://support.dixa.help/en/articles/1551-smart-conversation-replies'
            : undefined
        }
      />
      <FeatureCard
        title="Smart Summaries"
        description="Get to the heart of every interaction quickly."
        icon="list-ul"
        learnMoreLink={
          showLearnMore
            ? 'https://support.dixa.help/en/articles/1616-smart-conversation-summaries'
            : undefined
        }
      />
      <FeatureCard
        title="Smart Translations"
        description="Break down language barriers effortlessly."
        icon="translate"
        learnMoreLink={
          showLearnMore
            ? 'https://support.dixa.help/en/articles/1702-ai-translations'
            : undefined
        }
      />
      <FeatureCard
        title="AI Spellchecker"
        description="Perfect your writing effortlessly with advanced AI."
        icon="grammar-spelling"
        learnMoreLink={
          showLearnMore
            ? 'https://support.dixa.help/en/articles/1709-ai-spellchecker'
            : undefined
        }
      />
      <FeatureCard
        title="Improve Reply"
        description="Communicate with precision, and on the tone."
        icon="pen"
        learnMoreLink={
          showLearnMore
            ? 'https://support.dixa.help/en/articles/1736-improve-reply'
            : undefined
        }
      />
    </FlexBox>
  );
};
